import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import Icon from 'shared/components/icon';
import AvatarImage from 'shared/components/avatar-image';
import {ImpostorModeContext} from 'src/components/ImpostorModeContext';

const propTypes = {
  onClick: PropTypes.func,
};

const ConnectionButton = ({onClick}) => {
  const impostorModeContext = useContext(ImpostorModeContext);

  if (!impostorModeContext.currentConnection) return null;

  const {
    connectedUser: {firstName, lastName, email, image},
  } = impostorModeContext.currentConnection;

  return (
    <button className="shared-impostor-toolbar-connection-button" type="button" onClick={onClick}>
      <AvatarImage userInfo={{firstName, lastName, image}} />
      <span className="shared-impostor-toolbar-connection-button-text">{firstName || email}</span>
      <Icon className="shared-impostor-toolbar-chervon" iconType="chevron-down" />
    </button>
  );
};

ConnectionButton.propTypes = propTypes;

export default ConnectionButton;
